import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { WelcomeComponent } from "./welcome.component";
import { WelcomeGuard } from "../../guards/welcome.guard";

const routes: Routes = [
  {
    path: "",
    component: WelcomeComponent,
    canActivate: [WelcomeGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WelcomeRoutingModule {}
